var map = {
	"./black/setting.png": "6owm",
	"./blue/setting.png": "V62w",
	"./white/setting.png": "3Bxs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wcbN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/setting\.png$
// module id = wcbN
// module chunks = 24